import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJMobileImageToImageInput.module.less';
import FJMobileUpload from '../../../assets/svg/mobile-add.svg?react';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
import FJMobileTextarea from '../../../common/components/FJMobileTextarea/FJMobileTextarea';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useRef } from 'react';

const FJMobileImageToImageInput = props => {
    const { prompt, uploadImageInfo = {}, changePrompt, uploadImg } = props;
    const { src: imgSrc } = uploadImageInfo;
    const inputRef = useRef(null);
    const _onClick = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };
    return (
        <div className={styles.input_box}>
            <div className={styles.preview_box} onClick={_onClick}>
                {imgSrc && <img className={styles.preview_img} src={imgSrc} alt='' loading='lazy' />}
                <div className={classNames(styles.preview_mask, imgSrc ? styles.transparent : '')}>
                    <FJMobileUpload />
                    {!imgSrc && <span className={styles.upload_text}>{FJLocalStore._('upload-image')}</span>}
                </div>
                <input
                    type='file'
                    ref={inputRef}
                    className={styles.file_input}
                    accept={UPLOAD_FILE_TYPE_NO_GIF}
                    onChange={_onUploadImg}
                />
            </div>
            <FJMobileTextarea
                className={styles.textarea}
                text={prompt}
                placeholder={FJLocalStore._('describe-the-image-briefly-to-get-more-accurate-results')}
                onChange={changePrompt}
                maxLength={200}
            />
        </div>
    );
};
FJMobileImageToImageInput.propTypes = {
    prompt: PropTypes.string,
    uploadImageInfo: PropTypes.object,
    changePrompt: PropTypes.func,
    imgSrc: PropTypes.string,
    uploadImg: PropTypes.func,
};
export default FJMobileImageToImageInput;
